import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// Initial console log to verify script is loading
console.log("=== HOMEPAGE.JS LOADED ===", new Date().toISOString());

const mm = gsap.matchMedia();
const breakPoint = 1024;
const isDesktop = `(min-width: ${breakPoint}px)`;
const isMobile = `(max-width: ${breakPoint - 1}px)`;

// document dom ready
function cloneForInfiniteScroll(el, minItems) {
    // Remove existing clones
    el.querySelectorAll('[data-clone]').forEach(clone => clone.remove());

    const originalChildren = Array.from(el.children);
    const count = originalChildren.length;
    if (count === 0 || count >= minItems) return;

    const clonesNeeded = minItems - count;
    const timesToRepeat = Math.ceil(clonesNeeded / count);

    for (let i = 0; i < timesToRepeat; i++) {
        originalChildren.forEach(child => {
            const clone = child.cloneNode(true);
            clone.setAttribute('data-clone', '');
            el.appendChild(clone);
        });
    }
}

function animateHero() {
    const MIN_ITEMS = 6;
    const scrollEls = document.querySelectorAll("#hero-images-loops .scroll-el");

    Array.from(scrollEls).forEach((el, index) => {
        if (el.children.length === 0) return;

        cloneForInfiniteScroll(el, MIN_ITEMS);

        mm.add(isDesktop, () => {
            let fromY, toY;
            if (index % 2) {
                fromY = "-50%";
                toY = "0%";
            } else {
                fromY = "0%";
                toY = "-50%";
            }
            console.log(`[animateHero] Desktop animation ${index}:`, { fromY, toY, duration: el.scrollHeight/100 });
            gsap.fromTo(el, {
                y: fromY,
            }, {
                y: toY,
                duration: el.scrollHeight/100,
                repeat:-1,
                ease: "none",
            });
        });
        mm.add(isMobile, () => {
            let fromX, toX;

            if (index % 2) {
                fromX = el.scrollWidth * -0.5 + "px";
                toX = "0%";
            } else {
                fromX = "0%";
                toX = el.scrollWidth * -0.5 + "px";
            }
            console.log(`[animateHero] Mobile animation ${index}:`, { fromX, toX, duration: el.scrollWidth/100 });
            gsap.fromTo(el, {
                x: fromX,
            }, {
                x: toX,
                duration: el.scrollWidth/100,
                repeat:-1,
                ease: "none",
            });

        });

    });
}
function animateNumbers() {
    Array.from(document.querySelectorAll("[data-animate-number]")).forEach((el, index) => {        
        gsap.from(el, {
            scrollTrigger: {
                trigger: el,
                // scrub: true,
                // start: "top bottom",
                // end: "top top"
            },
            duration: 1,
            ease: 'circ.out',
            textContent: 0,
            snap: { textContent: 1 },
        })
    });
}
function animateBrandLogos() {
    Array.from(document.querySelectorAll("[data-home-logo-carousel]")).forEach((el, index) => {
        mm.add(isDesktop, () => {
            let from, to; 
            if (index % 2) {
                from = "-19.25rem";
                to = "0%";
            } else {
                from = "0%";
                to = "-19.25rem";
            }
            gsap.fromTo(el, {
                x: from,
            }, {
                scrollTrigger: {
                    trigger: el,
                    scrub: true,
                    // start: "top bottom",
                    // end: "top top"
                },
                x: to,
                duration: el.scrollHeight/100,
                // repeat:-1, 
                ease: "none",
            });
        });
        mm.add(isMobile, () => {
            let from, to; 
            if (index % 2) {
                from = -.16 * el.scrollWidth + "px";
                to = "0%";
            } else {
                from = "0%";
                to = -.16 * el.scrollWidth + "px";
            }
            gsap.fromTo(el, {
                x: from,
            }, {
                scrollTrigger: {
                    trigger: el,
                    scrub: true,
                    // start: "top bottom",
                    // end: "top top"
                },
                x: to,
                duration: el.scrollHeight/100,
                // repeat:-1, 
                ease: "none",
            });

        });
        
    });
}
function animateInstaFeeds() {
    Array.from(document.querySelectorAll("[data-instagram-container]")).forEach((el, index) => {
        mm.add(isDesktop, () => {
            let from, to; 
            if (index % 2) {
                from = "-10.25rem";
                to = "5rem";
            } else {
                from = "2rem";
                to = "-19.25rem";
            }
            gsap.fromTo(el, { y: from, }, {
                scrollTrigger: {
                    trigger: el, 
                    scrub: true,
                },
                y: to, 
                ease: "none",
            });
        });
        mm.add(isMobile, () => {
            let from, to; 
            if (index % 2) {
                to = "3rem";
                from = "-12rem";
            } else {
                from = "3rem";
                to = "-12rem";
            }
            gsap.fromTo(el, { x: from, }, {
                scrollTrigger: {
                    trigger: el,
                    scrub: true,
                },
                x: to,
                ease: "none",
            });
        });
        
    });
}

document.addEventListener("DOMContentLoaded", function () {
    animateHero();
    animateNumbers();
    animateBrandLogos();
    
    
});
document.addEventListener("instagram-loaded", function() {
    animateInstaFeeds();
})

